var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowGreenUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.114292 7.34603C0.356462 7.9296 0.984797 8.34598 1.62949 8.33794C2.05984 8.33794 2.49509 8.15467 2.79944 7.84761L5.3533 5.32283V15.1668C5.3533 15.5896 5.52021 16.0108 5.81801 16.3099C6.11581 16.6105 6.53798 16.7938 6.96668 16.8002C7.39539 16.8066 7.83228 16.6362 8.13663 16.3243C8.44752 16.0253 8.62097 15.5961 8.61442 15.1668V5.30167L11.1887 7.84761C11.4799 8.15467 11.9087 8.33794 12.3455 8.34598C12.7742 8.34598 13.2111 8.17396 13.5155 7.87655C13.8264 7.58235 14.0064 7.15633 13.9998 6.73353C13.9933 6.30429 13.8051 5.8831 13.5008 5.59051L8.42663 0.57151C7.65267 -0.190503 6.32237 -0.190503 5.55495 0.57151L0.48082 5.59051C0.0242961 6.03261 -0.127879 6.75443 0.114292 7.34603Z",
    fill: "url(#arrowup_paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrowup_paint0_linear",
    x1: 4.72253,
    y1: 25.2005,
    x2: 20.2021,
    y2: 16.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6DE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CE00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreenUp);
export default __webpack_public_path__ + "static/media/arrowGreenUp.9a5cb5f3a6126b6a7fc504b196a70696.svg";
export { ForwardRef as ReactComponent };